import { render, staticRenderFns } from "./switchCharts.vue?vue&type=template&id=3e8c25ff&scoped=true"
import script from "./switchCharts.vue?vue&type=script&lang=js"
export * from "./switchCharts.vue?vue&type=script&lang=js"
import style0 from "./switchCharts.vue?vue&type=style&index=0&id=3e8c25ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8c25ff",
  null
  
)

export default component.exports